<template>
    <div>
        <center>
            <h3>Family Timeline</h3>
        </center>
    </div>
</template>

<script>
export default {
  name: "FamilyTimeline"
};
</script>